export enum VehicleCardEnum {
    Search=1,
    MyBooking=2,
    Booking = 3,
    ViewBooking=4
  }


